<template>
    <input
            :id="id"
            :name="name"
            v-model="number"
            type="textbox"
            @keydown="keydown"
            @change="onChange"
            :style="styles"
            pattern="\d*"
            @blur="isInputActive = false"
            @focus="isInputActive = true"
            :placeholder="placeholder"
            :disabled="disabled"
    />
</template>

<script>
    export default {
        name: 'c-input-number',
        inheritAttrs: true,
        props: {
            icon: {
                type: String,
                default: 'Table'
            },
            styles: {
                type: String,
                default: 'text-align:right'
            },
            value: {
                type: [String, Number],
            },
            disabled: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },

            id: {
                type: [String, Number],
                default: ''
            },
            name: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
        },
        data: () => {
            return {
                isInputActive: false,
                number: ""
            }
        },

        mounted() {
        },

        watch:{
          value(data){
              //console.log("--- value change ---");
              //console.log(data);
              //console.log(this.value);
              this.convert();
          }
        },

        created(){
          this.convert();
        },

        methods: {
            convert(){
                // console.log("==========");
                // console.log(this.value);
                // console.log(this.value == undefined);
                // console.log(this.value == null);
                // console.log(this.value === "");
                // console.log(isNaN(this.value));
                // console.log("==========");
                if(this.value == undefined || this.value == null || this.value === "" || isNaN(this.value) ){
                    this.number = null;
                } else {
                    this.number = this.value.toLocaleString("vi-VN");
                }
                // console.log(this.number);
            },

            onChange: function ($event) {
                this.handleInput();
                this.$emit('change', $event);
            },

            handleInput: function(){
                //console.log(this.number);
                let n =this.number;
                n = n.replace(/\./g, "");
                //console.log(n);
                n = n.replace(",", ".");
                //console.log(n);

                if (isNaN(n)) {
                    n = 0;
                }
                n = Number(n);
                this.$emit('input', n);
                //console.log(n);
                this.number = n.toLocaleString("vi-VN");
                //console.log(this.number);
                this.$forceUpdate();
                // console.log("input444", val);
            },

            keydown: function (target) {
                this.$emit('keydown', target);
            },
            keyup: function (target) {
                this.$emit('keyup', target);
            },
        }
    }
</script>
